export default {
  IFRAME_DIMENSIONS_UPDATED: 'IFRAME_DIMENSIONS_UPDATED',
  IFRAME_WINDOW_RESIZED: 'IFRAME_WINDOW_RESIZED',
  //
  WINDOW_SCROLLED: 'WINDOW_SCROLLED',
  WIDGET_READY: 'WIDGET_READY',
  WIDGET_SCROLL_TOP: 'WIDGET_SCROLL_TOP',
  IFRAME_BLURRED: 'IFRAME_BLURRED',
  EVENT_CLICKED: 'EVENT_CLICKED',
  ADMISSION_GROUP_CREATED: 'ADMISSION_GROUP_CREATED',
  INVENTORY_SELECTED: 'INVENTORY_SELECTED',
  CHECKOUT: 'CHECKOUT',
  BOOKING_COMPLETED: 'BOOKING_COMPLETED',
  LOG_IN: 'LOG_IN',
  LOG_OUT: 'LOG_OUT',
  //chat
  SHOW_CHAT_APP: 'SHOW_CHAT_APP',
  HIDE_CHAT_APP: 'HIDE_CHAT_APP',
  //modals
  SHOW_MODAL: 'SHOW_MODAL',
  MODAL_CLOSED: 'MODAL_CLOSED',
  //redirect
  REDIRECT: 'REDIRECT',
}



// WEBPACK FOOTER //
// ./src/shared/constants/iframeMessageTypes.js